import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 400px;
  padding: 0 10px;
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 60px;
  animation: ${appearFromLeft} 1s;

  img {
    border-radius: 50%;
    margin-bottom: 20px;
  }

  @media (max-width: 650px) {
    img {
      width: 120px;
      height: 120px;
    }
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  h1 {
    padding: 10px;
  }

  @media (max-width: 650px) {
    h1 {
      font-size: 25px;
    }
  }
`;
